import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginWithGoogle } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    (async () => {
      try {
        if (!sessionId) throw new Error("missing session_id");
        await loginWithGoogle(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true });
      } catch (err) {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/login", { replace: true });
      }
    })();
  }, [loginWithGoogle, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center gap-2 text-muted-foreground" data-testid="auth-callback">
      <Loader2 className="h-5 w-5 animate-spin" /> Signing in...
    </div>
  );
}
